import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Sidebar from './components/sidebar/Sidebar';
import Dashboard from './components/dashboard/Dashboard';
import DomainList from './components/domains/DomainList';
import PixelList from './components/pixels/PixelList';
import DatasetList from './components/datasets/DatasetList';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import PrivateRoute from './components/auth/PrivateRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Rotas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        
        {/* Rotas protegidas */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={
            <div className="app">
              <Sidebar />
              <div className="content">
                <Container fluid>
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/domains" element={<DomainList />} />
                    <Route path="/pixels" element={<PixelList />} />
                    <Route path="/datasets" element={<DatasetList />} />
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                </Container>
              </div>
            </div>
          } />
          <Route path="/dashboard" element={
            <div className="app">
              <Sidebar />
              <div className="content">
                <Container fluid>
                  <Dashboard />
                </Container>
              </div>
            </div>
          } />
          <Route path="/domains" element={
            <div className="app">
              <Sidebar />
              <div className="content">
                <Container fluid>
                  <DomainList />
                </Container>
              </div>
            </div>
          } />
          <Route path="/pixels" element={
            <div className="app">
              <Sidebar />
              <div className="content">
                <Container fluid>
                  <PixelList />
                </Container>
              </div>
            </div>
          } />
          <Route path="/datasets" element={
            <div className="app">
              <Sidebar />
              <div className="content">
                <Container fluid>
                  <DatasetList />
                </Container>
              </div>
            </div>
          } />
        </Route>
        
        {/* Redirecionar para login se a rota não existir */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
